import { Link } from "react-router-dom";
import React from "react";

export default function LaunchpadPanel(props: any) {
    return (
        <div className='mintPanel' style={{gap: '15px'}}>
            <div>
                <div style={{width: '200px', height: '200px'}}><img alt={props.collection} title={props.collection} height='200px' src={props.img} /></div>
            </div>
            <div className='flexColumn' style={{width: '100%'}}>
                <div className='mintTitle'>{props.title}</div>
                <div className='mintText'>{props.text}</div>
                <div style={{marginTop: '5px'}}>
                    <Link to={'/mint/' + props.collection}><button className='mintButton'>Go to Launchpad</button></Link>
                </div>
            </div>
        </div>
    );
}